import React, { useState } from 'react';
import { useLanguage } from '../../providers/preferenceProvider';
import '../../css/overlay.css';

const UploadCsv = ({ isOpen, onClose, handleSave, result }) => {
  const { t } = useLanguage();
  const [file, setFile] = useState(null);

  if (!isOpen) return null;

  const handleUpload = (event) => {
    const uploaded = event.target.files[0];
    if (uploaded) {
      const reader = new FileReader();
      reader.readAsDataURL(uploaded);
    }
    setFile(uploaded);
  };

  return (
    <div className="overlay-backdrop" onClick={onClose}>
      <div className="import-overlay" onClick={(e) => e.stopPropagation()}>
        <div className="overlay-header">Import users</div>
        <div className="overlay-admin-form flex flex-col gap-4 p-2">
          <div className="flex flex-row justify-between items-center gap-4">
            <div className="flex flex-col gap-2">
              <label htmlFor="image-upload" className="cursor-pointer">
                <input type="file" id="upload" accept="text/csv" onChange={handleUpload} />
                {t.upload_image}
              </label>
            </div>

            <div className="flex flex-row-reverse gap-2">
              <button className="btn" onClick={() => handleSave(file)} disabled={!file}>
                {t.confirm}
              </button>
              <button className="btn-close" onClick={onClose}>{t.close}</button>
            </div>
          </div>
        </div>
        
        <div className='overflow-y-auto max-h-[25rem]'>
          {result.successes && result.successes.length > 0 && (
            <div className="import-result import-result-success mt-4">
              <h3 className="px-2 py-2 border rounded-[7px] mt-2 mb-2">Import successes:</h3>
              <ul>
                {result.successes.map((success, index) => (
                  <li key={index}>{success}</li>
                ))}
              </ul>
            </div>
          )}

          {result.errors && result.errors.length > 0 && (
            <div className="import-result import-result-error mt-4">
              <h3 className="px-2 py-2 border rounded-[7px] mt-2 mb-2">Import errors:</h3>
              <ul>
                {result.errors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};


export default UploadCsv;